import MinimalReportViewer from "./MinimalReportViewer";

function ReportViewPage() {
  return <MinimalReportViewer />;
}

export default ReportViewPage;
